//#region src/core/i18n/locales/tr.ts
var tr_default = {
	buttons: {
		play: "Oynat",
		pause: "Duraklat",
		replay: "Yeniden Oynat",
		mute: "Sessiz",
		unmute: "Sesi Aç"
	},
	seek: {
		forward: "{seconds} saniye ileri sar",
		backward: "{seconds} saniye geri sar"
	},
	fullscreen: {
		enter: "Tam Ekran",
		exit: "Tam ekrandan çık"
	},
	captions: {
		enable: "Altyazıları aç",
		disable: "Altyazıları kapat"
	},
	pip: {
		enter: "Mini oynatıcı",
		exit: "Mini oynatıcıdan çık"
	},
	live: {
		playing: "Canlı oynatılıyor",
		seekToEdge: "Canlıya git",
		badge: "Canlı"
	},
	cast: {
		start: "Yansıtmayı başlat",
		stop: "Yansıtmayı durdur",
		connecting: "Bağlanıyor"
	},
	airplay: {
		start: "AirPlay'i başlat",
		stop: "AirPlay'i durdur"
	},
	slider: { seek: "Ara" },
	time: {
		current: "Süre",
		duration: "Toplam Süre",
		remaining: "Kalan Süre",
		elapsedSuffix: "{duration} geçen süre",
		durationSuffix: "{duration} toplam süre",
		remainingSuffix: "{duration} kaldı",
		showElapsed: "Geçen süreyi göster, {duration}.",
		showDuration: "Süreyi göster, {duration}.",
		showRemaining: "Kalan süreyi göster, {duration}.",
		toggleElapsed: "Geçen süre ile kalan süre arasında geçiş yapın.",
		toggleDuration: "Toplam süre ile kalan süre arasında geçiş yapın.",
		position: "{current} / {duration}",
		unknown: "Medya yüklenmedi, süre bilinmiyor."
	},
	playback: { rate: "Oynatma Hızı {rate}" },
	volume: {
		mutedValue: "{percent}, sessiz",
		muted: "Sessiz",
		label: "Ses",
		value: "Ses {value}"
	},
	status: {
		captionsOn: "Altyazılar açık",
		captionsOff: "Altyazılar kapalı",
		paused: "Duraklatıldı",
		playing: "Oynatılıyor",
		fullscreen: "Tam ekran",
		pip: "Resim içinde resim",
		exitPip: "Resim içinde resimden çık",
		seekedTo: "{time} konumuna gidildi"
	},
	container: { label: "Medya oynatıcı" },
	errors: {
		aborted: "Medyayı oynatmayı iptal ettiniz",
		network: "Medya indirme işleminin kısmen başarısız olmasına neden olan bir ağ sorunu oluştu.",
		decode: "Medya oynatma, bir bozulma sorunu nedeniyle veya medya, tarayıcınızın desteklemediği özellikleri kullandığı için durduruldu.",
		source: "Sunucu veya ağ hatasından ya da biçim desteklenmediğinden medya yüklenemedi.",
		encrypted: "Medya, şifrelenmiş bir kaynaktan geliyor ve oynatmak için gerekli anahtar bulunamadı.",
		unplayable: "Bu medya oynatıcı tarafından desteklenmiyor.",
		title: "Bir şeyler ters gitti.",
		unexpected: "Bir hata oluştu. Lütfen tekrar deneyin."
	},
	common: {
		empty: "",
		ok: "Kapat"
	},
	menu: {
		settings: "Ayarlar",
		quality: "Kalite",
		audio: "Ses",
		default: "Varsayılan",
		speed: "Hız",
		captions: "Altyazılar",
		playbackRate: "Oynatma hızı",
		back: "Geri",
		off: "Kapalı",
		auto: "Otomatik",
		autoWithLabel: "Otomatik ({label})",
		subtitles: "Altyazılar"
	}
};
//#endregion
export { tr_default as default };

//# sourceMappingURL=tr.js.map